// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"wrapper___S8SG_","img":"img___1gyIf","title":"title___2IuI6","content":"content___10UUf","btnLine":"btnLine___2oWIr"};